// src/components/common/InstallModal.js
import React from 'react';
import { X, Share2, Download, ChevronRight } from 'lucide-react';
import { installApp } from '../../utils/installUtils';  // Add this import

const InstallModal = ({ isOpen, onClose, isIOS }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
      <div className="relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-md bg-white">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-medium">Add to Home Screen</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500">
            <X className="h-6 w-6" />
          </button>
        </div>

        {isIOS ? (
          <div className="space-y-4">
            <div className="flex items-center text-gray-700">
              <div className="mr-4">
                <Share2 className="h-8 w-8 text-blue-500" />
              </div>
              <div>
                <p className="font-medium">Step 1</p>
                <p className="text-sm">Tap the Share button in your browser</p>
              </div>
            </div>

            <div className="flex items-center text-gray-700">
              <div className="mr-4">
                <Download className="h-8 w-8 text-blue-500" />
              </div>
              <div>
                <p className="font-medium">Step 2</p>
                <p className="text-sm">Tap 'Add to Home Screen' in the share menu</p>
              </div>
            </div>

            <div className="flex items-center text-gray-700">
              <div className="mr-4">
                <ChevronRight className="h-8 w-8 text-blue-500" />
              </div>
              <div>
                <p className="font-medium">Step 3</p>
                <p className="text-sm">Tap 'Add' to confirm</p>
              </div>
            </div>

            <div className="mt-6 text-sm text-gray-500">
              <p>You'll be able to access the app directly from your home screen.</p>
            </div>
          </div>
        ) : (
          <div className="space-y-4">
            <p className="text-gray-600">
              Click 'Install' to add this app to your home screen for quick access.
            </p>
            <div className="flex justify-end space-x-3">
              <button
                onClick={onClose}
                className="px-4 py-2 border rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                onClick={async () => {
                  onClose();
                  await installApp();
                }}
                className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700"
              >
                Install
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default InstallModal;